
import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import { RaiseTicketWithDocument, TicketChatboxModal, DateRangePicker } from "./TicketModelComponent";
import { DownloadIcon, Eye, Filter, SearchBig } from "../../utils/ReusableSVGs"
import { formatDate, formatDateTime, formattedDateLong } from "../../utils/DateFormattings";
import { ViewChatImageorFile } from "../../utils/ReusableFunctions";
import { BASE_URL, IMAGE_URL, TESTING_URL } from "./axios";

import { useLocation, useNavigate } from "react-router-dom";
// import Dashboardnavbar from '../../layout/Dashboardnavbar';
import { Modal } from "react-bootstrap";


const CloseRequest = ({ id }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        is_resolved: "",
    });

    console.log(formData);
    //******************Valedation Start********************* */

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["is_resolved"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleFormSubmitPut = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(`${BASE_URL}/ticket/ticketclose/${id}/`, {
                    is_resolved: true,

                    close_by: sessionStorage.getItem('email'),
                });

                if (res.status === 200) {
                    // await getImprestname();
                    setShow(false);
                } else {
                    alert(res);
                }
            } catch (err) {
                //   handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div className="" >
                <button className="model-button model-button-black  my-5px font-weight500" onClick={handleShow}>
                    Close Ticket
                </button>
            </div>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="flex-column">
                                <label htmlFor="is_resolved" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                    Ticket Closing Remark
                                </label>
                                <textarea
                                    id="is_resolved"
                                    type="text"
                                    name="is_resolved"
                                    placeholder="Remarks"
                                    onChange={handleInputChange}
                                    maxLength={100}
                                    value={formData.is_resolved}
                                    className={`form-input-textarea   font-weight400  font-size-subheading ${errors.is_resolved
                                        ? "error"
                                        : inputState.is_resolved
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.is_resolved && (
                                    <span className="error-message font-size-text ">{ }</span>
                                )}
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel   font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-delete    font-size-heading"
                                    onClick={handleFormSubmitPut}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const RaisedTickets = () => {
    const [buffer, setBuffering] = useState(true); //buffering logic
    const [show, setShow] = useState(false);
    const [indexRow, setIndexRow] = useState({});
    const handleClose = () => setShow(false);
    const handleShow = (e) => {
        setShow(true);
        setIndexRow(e);
    };
    // *********** Employee Details Api Start ***********
    const [ticketsList, setTicketsList] = useState([]);
    const [filteredTicketsList, setFilteredTicketsList] = useState([]);

    const getAllTicketsList = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/ticket/ticket/`
            );
            setTicketsList(res.data);

            const uniqueDayStatus = [
                ...new Set(res.data.map((entry) => entry.status)),
            ];
            setStatus_list(uniqueDayStatus);
            const uniquePriorityStatus = [
                ...new Set(res.data.map((entry) => entry.priority)),
            ];
            setPriority_status(uniquePriorityStatus);
        } catch (err) {
            // handleErrorToast(err)
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };
    useEffect(() => {
        getAllTicketsList();
    }, []);
    // *********** Employee Details Api End ***********

    const [startdate, setStartDate] = useState(``);

    const [enddate, setEndDate] = useState(``);

    // *********** Filter Logic ***********

    // const [selectedStatus, setSelectedStatus] = useState([
    //     "open",
    //     "acceptance",
    //     "completed",
    //     "close",
    //     "pending",
    //     "inprocess",
    // ]);

    const [status_list, setStatus_list] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(status_list);
    const [asignee, setAsignee] = useState("");
    const [asigning, setAsigning] = useState("");
    const [priority, setPriority] = useState("");
    const [priority_status, setPriority_status] = useState([]);

    function handlePriority(value) {
        if (value == 1) {
            return (
                <button className="priority-button font-weight600 Color-tab-red">
                    High
                </button>
            );
        } else if (value == 2) {
            return (
                <button className="priority-button font-weight600 Color-tab-yellow">
                    Medium
                </button>
            );

        } else if (value == 3) {
            return (
                <button className="priority-button font-weight600 Color-tab-blue">
                    Low
                </button>
            );
        } else return <td className="align-center"></td>;
    }

    const handleSearch = () => {
        let filteredData = ticketsList;


        if (selectedStatus.length > 0) {
            filteredData = filteredData.filter((employee) =>
                selectedStatus.includes(employee.status)
            );
        }
        if (selectedStatus.length === 0) {
            filteredData = filteredData.filter((employee) =>
                // ["pending", "inprocess", "completed"].includes(employee.status)
                status_list.includes(employee.status)
            );
        }

        if (priority !== "") {
            if (priority === "1") {
                filteredData = filteredData.filter(
                    (employee) => employee.priority === priority
                );
            } else if (priority === "2") {
                filteredData = filteredData.filter(
                    (employee) => employee.priority === priority
                );
            } else if (priority === "3") {
                filteredData = filteredData.filter(
                    (employee) => employee.priority === priority
                );
            }
        }
        if (asignee) {
            const lowercaseSelectedName = asignee.toLowerCase();
            filteredData = filteredData.filter((employee) => {
                const assigneeNameMatch = employee.assigned_by_name
                    .toLowerCase()
                    .includes(lowercaseSelectedName);

                const assigneeEmailMatch = employee.assigned_by
                    .toLowerCase()
                    .includes(lowercaseSelectedName);

                const title = employee.title
                    .toLowerCase()
                    .includes(lowercaseSelectedName);

                const description = employee.description
                    .toLowerCase()
                    .includes(lowercaseSelectedName);

                return (
                    assigneeNameMatch || assigneeEmailMatch || title || description
                );
            });
        }

        if (startdate !== "") {
            filteredData = filteredData.filter(
                (employee) =>
                    employee.due_date >= startdate && employee.assign_date >= startdate
            );
        }
        if (enddate !== "") {
            filteredData = filteredData.filter(
                (employee) =>
                    employee.due_date <= enddate && employee.assign_date <= enddate
            );
        }

        setFilteredTicketsList(filteredData);
    };

    useEffect(() => {
        handleSearch();
    }, [
        selectedStatus,
        ticketsList,
        asignee,
        startdate,
        enddate,
        asigning,
        priority,
    ]);

    const statusName = [
        {
            status: "open",
            name: "Open",
        },
        {
            status: "acceptance",
            name: "Acceptance",
        },
        {
            status: "pending",
            name: "Pending",
        },
        {
            status: "inprocess",
            name: "In Process",
        },
        {
            status: "completed",
            name: "Completed",
        },
        {
            status: "close",
            name: "Close",
        },
    ];

    const options = statusName.map((e) => ({
        value: e.status,
        label: e.name,
    }));

    const handleChangecc = (selected) => {
        const multipleperson =
            selected.length > 0 ? selected.map((item) => item.value) : "";
        setSelectedStatus(multipleperson);
    };

    const createMarkup = (content) => {
        const linkRegex = /(?:https?|ftp):\/\/[^\s]+/g;
        return {
            __html: content.replace(linkRegex, (url) => {
                return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
            }),
        };
    };

    const navigate = useNavigate();
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    const ticketUrl = "/" + urlParts[3] + "/ticket/";
    const ViewTicketDetails = (i) => {
        navigate(ticketUrl + i + '/', { state: { i } });
    };


    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <div className="content-tabs">
                <div className="attendance-subcont">
                    <div className="field-cont">
                        {/* <div className="field-cont-div">
                            <input
                                className="attendance-input-field width-10vw   date-field"
                                placeholder="From Date"
                                type="date"
                                value={startdate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            <input
                                className="attendance-input-field width-10vw   date-field"
                                placeholder="To Date"
                                type="date"
                                value={enddate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                            <hr className="field-cont-hr" />
                        </div> */}
                        <div title=' Date Range' className="field-cont-div ">

                            <DateRangePicker startDate={startdate} endDate={enddate} placeHolder1="From Date" placeHolder2="To Date" onChange={(start, end) => {
                                setStartDate(start);
                                setEndDate(end);

                            }} />
                            <hr className="field-cont-hr" />
                        </div>

                        <div className="field-cont-div">
                            <Filter />
                            <Select
                                className="attendance-input-field width-15vw  "
                                width="200px"
                                options={options}
                                placeholder="Status"
                                isMulti
                                onChange={handleChangecc}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        color: '#707070',
                                        outline: 'none',
                                        border: 'none',
                                        // padding: '0.6rem 0.5rem',
                                        textTransform: 'capitalize',
                                        boxShadow: 'none',
                                        '&:hover': {
                                            border: 'none',
                                        },
                                    }),
                                    singleValue: (provided) => ({
                                        ...provided,
                                        color: '#707070',
                                    }),
                                    placeholder: (provided) => ({
                                        ...provided,
                                        color: '#707070',
                                    }),
                                    dropdownIndicator: (provided) => ({
                                        ...provided,
                                        filter: 'invert(50%)',
                                        cursor: 'pointer',
                                        left: '9.5rem',
                                        width: '20px',
                                        height: '20px',
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999, // Ensure dropdown menu appears above other elements
                                    }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        color: state.isSelected ? '#2576bc' : '#707070',
                                        backgroundColor: state.isSelected ? 'rgba(37,118,188,0.1)' : 'white',
                                        cursor: 'pointer',
                                        '&:hover': {
                                            backgroundColor: 'rgba(5, 205, 153, 0.1)',
                                        },
                                    }),
                                }}
                            />

                            <hr className="field-cont-hr" />
                        </div>

                        <div className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-10vw   date-field"
                                type="text"
                                value={priority}
                                onChange={(e) => setPriority(e.target.value)}
                            >
                                <option value="">Priority</option>
                                {priority_status
                                    .sort((a, b) => a - b)
                                    .map((prior) => (
                                        <option value={prior}>
                                            {prior === "1"
                                                ? "High"
                                                : prior === "2"
                                                    ? "Medium"
                                                    : prior === "3"
                                                        ? "Low"
                                                        : "All"}
                                        </option>
                                    ))}
                                ;
                            </select>
                            <hr className="field-cont-hr" />
                        </div>

                        <div className="field-cont-div-svg">
                            <SearchBig />
                            <input
                                className="attendance-input-field width-15vw  "
                                placeholder="By Task, Emp & Name"
                                type="text"
                                value={asignee}
                                onChange={(e) => setAsignee(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="btn-cont">

                    </div>
                </div>

                <div className="table-css-white-background">
                    <table className="table-css-ticket table-fixed w-full">
                        <thead>
                            <tr className="custom-table-head-tr">
                                <th className="w-1/10 align-left">Sr no.</th>
                                <th className="w-1/10 align-center">Request By</th>
                                <th className="w-1/10 align-center">Title</th>
                                <th className="w-1/10 align-center">Task</th>
                                <th className="w-1/10 align-center">Assigned Date</th>
                                <th className="w-1/10 align-center">Due date</th>
                                <th className="w-1/10 align-center">Chat History</th>
                                {/* <th className="w-1/10 align-center">Priorty</th> */}
                                <th className="w-1/10 align-right">Status</th>
                                <th className="w-1/10 align-right">Action</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <div className="spinner"></div> // buffering logic
                        ) : (
                            <tbody>
                                {filteredTicketsList
                                    .sort((a, b) => new Date(a.due_date) - new Date(b.due_date))
                                    .sort((a, b) => a.priority - b.priority)
                                    .map((i, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="custom-table-head-td">
                                                <td className="w-1/10 align-left">{index + 1}</td>
                                                <td className="w-1/10 align-center">
                                                    {i.assigned_by_name} <br /> {i.assigned_by}
                                                </td>
                                                <td className="w-1/10 align-center">{i.title}</td>
                                                <td className="w-1/10 align-center">
                                                    <div dangerouslySetInnerHTML={createMarkup(i.description)} />
                                                </td>
                                                <td className="w-1/10 align-center">
                                                    {formatDate(i.assign_date)}
                                                </td>
                                                <td className="w-1/10 align-center">
                                                    {formatDate(i.due_date)}
                                                </td>
                                                <td className="w-1/10 align-center">
                                                    {i.remarks?.map((edata, idx) => (
                                                        <div key={idx}>
                                                            By : {edata.name}
                                                            <br />
                                                            On: {formatDate(edata.created_at)}
                                                            <br />
                                                            {edata.remark_text}
                                                        </div>
                                                    ))}
                                                    <TicketChatboxModal
                                                        i={i.id}
                                                        getAllTasks={getAllTicketsList}
                                                    />
                                                </td>
                                                {/* <td className="w-1/10 align-center">
                                                    {i.priority ? handlePriority(i.priority) : "-"}
                                                </td> */}
                                                <td className="w-1/10 align-right">{i.status}</td>
                                                <td className="w-1/10 align-right">
                                                    <button
                                                        title="View Ticket Details"
                                                        onClick={() => ViewTicketDetails(i.id)}
                                                    >
                                                        <Eye />
                                                    </button>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
        </>
    );
};

const MyTickets = () => {
    const [buffer, setBuffering] = useState(true); //buffering logic
    const [show, setShow] = useState(false);
    const [indexRow, setIndexRow] = useState({});
    const handleClose = () => setShow(false);
    const handleShow = (e) => {
        setShow(true);
        setIndexRow(e);
    };
    // *********** Employee Details Api Start ***********
    const [ticketsList, setTicketsList] = useState([]);
    const [filteredTicketsList, setFilteredTicketsList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState("null");

    const getAllTicketsList = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/ticket/ticket-assigned-by/${sessionStorage.getItem("email")}/${selectedStatus}/`
            );
            setTicketsList(res.data);

            const uniqueDayStatus = [
                ...new Set(res.data.map((entry) => entry.status)),
            ];
            setStatus_list(uniqueDayStatus);
            const uniquePriorityStatus = [
                ...new Set(res.data.map((entry) => entry.priority)),
            ];
            setPriority_status(uniquePriorityStatus);
        } catch (err) {
            // handleErrorToast(err)
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };
    useEffect(() => {
        getAllTicketsList();
    }, [selectedStatus]);

    // *********** Employee Details Api End ***********

    const [startdate, setStartDate] = useState("");

    const [enddate, setEndDate] = useState("");

    // *********** Filter Logic ***********

    const [status_list, setStatus_list] = useState([]);
    const [asignee, setAsignee] = useState("");
    const [asigning, setAsigning] = useState("");
    const [priority, setPriority] = useState("");
    const [priority_status, setPriority_status] = useState([]);


    useEffect(() => {
        if (startdate === null && enddate === null) {
            setStartDate("");
            setEndDate("");
        }
    }, [startdate, enddate]);

    function handlePriority(value) {
        if (value == 1) {
            return (
                <button className="priority-button font-weight600 Color-tab-red">
                    High
                </button>
            );
        } else if (value == 2) {
            return (
                <button className="priority-button font-weight600 Color-tab-yellow">
                    Medium
                </button>
            );

        } else if (value == 3) {
            return (
                <button className="priority-button font-weight600 Color-tab-blue">
                    Low
                </button>
            );
        } else return <td className="align-center"></td>;
    }

    const handleSearch = () => {
        let filteredData = ticketsList;

        if (priority !== "") {
            if (priority === "1") {
                filteredData = filteredData.filter(
                    (employee) => employee.priority === priority
                );
            } else if (priority === "2") {
                filteredData = filteredData.filter(
                    (employee) => employee.priority === priority
                );
            } else if (priority === "3") {
                filteredData = filteredData.filter(
                    (employee) => employee.priority === priority
                );
            }
        }
        if (asignee) {
            const lowercaseSelectedName = asignee.toLowerCase();
            filteredData = filteredData.filter((employee) => {
                const assigneeNameMatch = employee.assigned_by_name
                    .toLowerCase()
                    .includes(lowercaseSelectedName);

                const assigneeEmailMatch = employee.assigned_by
                    .toLowerCase()
                    .includes(lowercaseSelectedName);

                const title = employee.title
                    .toLowerCase()
                    .includes(lowercaseSelectedName);

                const description = employee.description
                    .toLowerCase()
                    .includes(lowercaseSelectedName);

                return (
                    assigneeNameMatch || assigneeEmailMatch || title || description
                );
            });
        }

        if (startdate !== "" && enddate !== "") {
            filteredData = filteredData.filter(
                (employee) =>
                    employee.assign_date >= startdate && employee.assign_date <= enddate
            );
        } else if (startdate !== "") {
            filteredData = filteredData.filter(
                (employee) => employee.assign_date >= startdate
            );
        } else if (enddate !== "") {
            filteredData = filteredData.filter(
                (employee) => employee.assign_date <= enddate
            );
        }



        setFilteredTicketsList(filteredData);
    };

    useEffect(() => {
        handleSearch();
    }, [
        selectedStatus,
        ticketsList,
        asignee,
        startdate,
        enddate,
        asigning,
        priority,
    ]);

    const statusName = [
        {
            status: "open",
            name: "Open",
        },
        {
            status: "acceptance",
            name: "Acceptance",
        },
        {
            status: "pending",
            name: "Pending",
        },
        {
            status: "inprocess",
            name: "In Process",
        },
        {
            status: "completed",
            name: "Completed",
        },
        {
            status: "close",
            name: "Close",
        },
    ];

    const options = statusName.map((e) => ({
        value: e.status,
        label: e.name,
    }));

    const handleChangecc = (selected) => {
        const multipleperson =
            selected.length > 0 ? selected.map((item) => item.value) : "";
        setSelectedStatus(multipleperson);
    };

    const createMarkup = (content) => {
        const linkRegex = /(?:https?|ftp):\/\/[^\s]+/g;
        return {
            __html: content.replace(linkRegex, (url) => {
                return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
            }),
        };
    };

    const navigate = useNavigate();
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    const ticketUrl = "/" + urlParts[3] + "/ticket/";
    const ViewTicketDetails = (i) => {
        navigate(ticketUrl + i + '/', { state: { i } });
    };


    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <div className="content-tabs">
                <div className="attendance-subcont">
                    <div className="field-cont">
                        {/* <div className="field-cont-div">
                            <input
                                className="attendance-input-field width-10vw   date-field"
                                placeholder="From Date"
                                type="date"
                                value={startdate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                            <hr className="field-cont-hr" />
                        </div> */}
                        {/* <div className="field-cont-div">
                            <input
                                className="attendance-input-field width-10vw   date-field"
                                placeholder="To Date"
                                type="date"
                                value={enddate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                            <hr className="field-cont-hr" />
                        </div> */}
                        <div title=' Date Range' className="field-cont-div ">

                            <DateRangePicker startDate={startdate} endDate={enddate} placeHolder1="From Date" placeHolder2="To Date" onChange={(start, end) => {
                                setStartDate(start);
                                setEndDate(end);

                            }} />
                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-10vw   date-field"
                                type="text"
                                value={selectedStatus}
                                onChange={(e) => setSelectedStatus(e.target.value)}
                            >
                                <option value="null">All</option>
                                <option value="pending">Pending</option>
                                <option value="completed">Completed</option>
                                {/* {status_list.map((status) => (
                                    <option value={status}>{status}</option>
                                ))} */}
                            </select>
                            <hr className="field-cont-hr" />

                        </div>

                        {/* <div className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-10vw   date-field"
                                type="text"
                                value={priority}
                                onChange={(e) => setPriority(e.target.value)}
                            >
                                <option value="">Priority</option>
                                {priority_status
                                    .sort((a, b) => a - b)
                                    .map((prior) => (
                                        <option value={prior}>
                                            {prior === "1"
                                                ? "High"
                                                : prior === "2"
                                                    ? "Medium"
                                                    : prior === "3"
                                                        ? "Low"
                                                        : "All"}
                                        </option>
                                    ))}
                                ;
                            </select>
                            <hr className="field-cont-hr" />
                        </div> */}
                        <div className="field-cont-div-svg">
                            <SearchBig />
                            <input
                                className="attendance-input-field width-15vw  "
                                placeholder="By Task, Emp & Name"
                                type="text"
                                value={asignee}
                                onChange={(e) => setAsignee(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="btn-cont">
                        {/* <RaiseATicket getTicketList={getAllTicketsList} /> */}
                        {/* <RaiseTicketWithDocument getTicketList={getAllTicketsList} /> */}
                    </div>
                </div>

                <div className="table-css-white-background">
                    <table className="table-css-ticket table-fixed w-full">
                        <thead>
                            <tr className="custom-table-head-tr">
                                <th className="w-1/10 align-left">Sr no.</th>
                                <th className="w-1/10 align-center">Request By</th>
                                <th className="w-1/10 align-center">Title</th>
                                <th className="w-1/10 align-center">Task</th>
                                <th className="w-1/10 align-center">Assigned Date</th>
                                {/* <th className="w-1/10 align-center">Due date</th> */}
                                <th className="w-1/10 align-center">Chat History</th>
                                {/* <th className="w-1/10 align-center">Priority</th> */}
                                <th className="w-1/10 text-right">Status</th>
                                <th className="w-1/10 text-right">Action</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <div className="spinner"></div> //buffering logic
                        ) : (
                            <tbody>
                                {filteredTicketsList
                                    .sort((a, b) => new Date(a.due_date) - new Date(b.due_date))
                                    .sort((a, b) => a.priority - b.priority)
                                    .map((i, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="custom-table-head-td">
                                                <td className="w-1/10 align-left">{index + 1}</td>
                                                <td className="w-1/10 align-center">
                                                    {i.assigned_by_name} <br /> {i.assigned_by}
                                                </td>
                                                <td className="w-1/10 align-center">{i.title}</td>
                                                <td className="w-1/10 align-center">
                                                    <div dangerouslySetInnerHTML={createMarkup(i.description)} />
                                                </td>
                                                <td className="w-1/10 align-center">{formatDate(i.assign_date)}</td>
                                                {/* <td className="w-1/10 align-center">{formatDate(i.due_date)}</td> */}
                                                <td className="w-1/10 align-center">
                                                    {i.remarks?.map((edata, index) => (
                                                        <div key={index}>
                                                            By : {edata.name}
                                                            <br />
                                                            On: {formatDate(edata.created_at)}
                                                            <br />
                                                            {edata.remark_text}
                                                        </div>
                                                    ))}
                                                    <TicketChatboxModal i={i.id} getAllTasks={getAllTicketsList} clientemail={i.assigned_by}
                                                        clientname={i.assigned_by_name}
                                                        ticket_name={i.title}
                                                        status={i.status}
                                                        productname={i.ticket_for}
                                                    />


                                                </td>
                                                {/* <td className="w-1/10 align-center">
                                                    {i.priority ? handlePriority(i.priority) : '-'}
                                                </td> */}
                                                <td className="w-1/10 text-right">{i.status}</td>
                                                <td className="w-1/10 text-right">
                                                    <button
                                                        className=""
                                                        title="View Ticket Details"
                                                        onClick={() => ViewTicketDetails(i.id)}
                                                    >
                                                        <Eye />
                                                    </button>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
        </>
    );
};

const ViewTicket = () => {

    const navigate = useNavigate()
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split('/');
    const backUrl = "/" + urlParts[3] + `/ticket/`;

    const location = useLocation();
    const { i } = location.state;

    console.log("i")
    console.log(i)
    const backroute = () => {
        navigate(backUrl)
    }

    const [buffer, setBuffering] = useState(true); //buffering logic
    const [ticket, setTicketData] = useState([]);
    const [ticketChat, setTicketChat] = useState([]);

    const getTicketDetails = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const ticket = await axios.get(`${BASE_URL}/ticket/ticket/${i}/`);
            setTicketData(ticket.data);
            const chat = await axios.get(`${BASE_URL}/ticket/ticketChat-by-ticket/${i}/`);
            setTicketChat(chat.data);
        } catch (err) {
            // handleErrorToast(err)
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    useEffect(() => {
        getTicketDetails();
    }, []);


    const getTicketChat = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {

            const res = await axios.get(
                `${BASE_URL}/ticket/ticketChat-by-ticket/${i}/`
            );
            setTicketChat(res.data);
        } catch (err) {
            // handleErrorToast(err)
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    return (
        <>
            {/* <Dashboardnavbar name={"Ticket Details"} url="Ticket Managment" /> */}
            <div className="content-tabs">
                <>

                    <div className=" ">

                        <div className="flex-row justify-between mb-20">
                            <button className="model-button model-button-black font-weight500" onClick={backroute}>Back</button>
                            {
                                ticket.status !== "completed" &&
                                <CloseRequest id={ticket.id} />
                            }

                        </div>


                        <div className="table-css-white-background ">
                            <div className="flex-row justify-between">
                                <h2>
                                    Ticket ID: {ticket.id}
                                </h2>
                                <h4>
                                    <span
                                        className="priority-button behavior"
                                        data-status={ticket.status}
                                    >
                                        {ticket.status ? ticket.status.toUpperCase() : ''}
                                    </span>
                                </h4>
                            </div>
                            <div class="ticket-date">
                                Date Submitted:{" "}
                                {formattedDateLong(ticket.assign_date)}
                            </div>

                            <div class="ticket-desc-header">Title: "{ticket.title}"</div>
                            <hr />
                            <div className="ticket-desc">
                                <div class="ticket-desc-header">Description of Issue</div>
                                <p>{ticket.description}</p>
                            </div>
                        </div>
                        <hr />
                        <div className="table-css-white-background ">
                            <div className="flex-row justify-between">
                                <h3>
                                    Chat History:
                                </h3>
                                <TicketChatboxModal i={i} clientemail={ticket.assigned_by}
                                    clientname={ticket.assigned_by_name}
                                    ticket_name={ticket.title}
                                    status={ticket.status}
                                    getAllTasks={getTicketDetails}
                                    productname={ticket.ticket_for}

                                />

                            </div>

                            <ul className="chatbox">
                                {buffer ? (
                                    <div className="spinner"></div>
                                ) : ticketChat.length === 0 ? (
                                    <div
                                        className="align-center justify-center "
                                        style={{ alignSelf: "center" }}
                                    >
                                        - No Chat Historys 🪹 -
                                    </div>
                                ) : (
                                    <>
                                        {ticketChat
                                            .sort(
                                                (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
                                            )
                                            .map((i, index) => (
                                                <>
                                                    {i.sender == sessionStorage.getItem("email") ? (
                                                        <>
                                                            <p className="chat-reply-timestamp font-size-text">
                                                                {i.sender_name}
                                                            </p>
                                                            <div className="chat chat-reply">
                                                                <li className="p-li">
                                                                    {i.message ? (
                                                                        <>
                                                                            <p>{i.message}</p>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <ViewChatImageorFile
                                                                                textcss={'chat-photo-reply'}
                                                                                filesrc={i.document}
                                                                            />
                                                                        </>
                                                                    )}

                                                                </li>
                                                                <p className="chat-reply-timestamp pad-r text-right font-size-label">
                                                                    {formatDateTime(i.timestamp).full}
                                                                </p>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <p className="chat-incoming-timestamp font-size-text ">
                                                                {i.sender_name}
                                                            </p>
                                                            <div className="chat chat-incoming">
                                                                <li className="p-li">
                                                                    {i.message ? (
                                                                        <>
                                                                            <p>{i.message}</p>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <ViewChatImageorFile
                                                                                textcss={'chat-photo-incoming'}
                                                                                filesrc={i.document}
                                                                            />
                                                                        </>
                                                                    )}


                                                                </li>
                                                                <p className="chat-incoming-timestamp pad-r text-right font-size-label">
                                                                    {formatDateTime(i.timestamp).full}
                                                                </p>
                                                            </div>
                                                        </>
                                                    )}
                                                </>
                                            ))}
                                    </>
                                )}
                            </ul>
                        </div>
                    </div>

                </>
            </div>
        </>
    );
};

export { MyTickets, RaisedTickets, ViewTicket }